module.exports = __webpack_public_path__ + "img/20191115130937383.58ea3103.jpg";